<template>
    <div class="navigate-events-container">
        <div
            class="nav-events-button prev"
            title="Previous event"
            v-if="prevEventToken"
            @click="switchToNearbyEvent('prev')"
        >
        </div>
        <div
            class="nav-events-button next"
            title="Next event"
            v-if="nextEventToken"
            @click="switchToNearbyEvent('next')"
        ></div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '../../store/actionTypes';
const { mapState, mapActions, mapMutations } = createNamespacedHelpers('main');

export default {
    name: 'NavigateEventsBar',
    data() {
        return {}
    },
    props: {
        show: { type: Boolean }
    },
    methods: {
        ...mapActions({
            changeActivePlayback: types.CHANGE_ACTIVE_PLAYBACK,
            switchToNearbyEvent: types.SWITCH_TO_NEARBY_EVENT
        }),
        ...mapMutations({
            initVideoData: types.INIT_VIDEO_DATA
        })
    },
    computed: {
        ...mapState({
            nextEventToken: state => state.nextEventToken,
            prevEventToken: state => state.prevEventToken,
        })
    }
}
</script>
